// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-type-select-label[data-v-eab4f052] {\n  width: 100%;\n  text-align: right;\n  font-size: 0.85rem;\n}\n.comment-type-select-item-cont[data-v-eab4f052] {\n  width: 100%;\n}\n.comment-type-select-item-text[data-v-eab4f052] {\n  flex: 1;\n  font-size: 0.85rem;\n}", ""]);
// Exports
module.exports = exports;
